module.exports = __webpack_public_path__ + "static/media/blur-bg.a02e282d.jpg";